import React from 'react';
import Section from 'components/content/section';
import Typography from '@material-ui/core/Typography';
import ExportIcon from '@material-ui/icons/GetApp';
import ExportButton from './button';

export default function ShiftExportSection({ courseId, shifts, isLoading }) {
  return (
    <Section title="Export shift data">
      <Typography paragraph>
        Your course shift data can be downloaded below in CSV file format.
      </Typography>

      <Typography paragraph>
        <ExportButton
          courseId={courseId}
          shifts={shifts}
          isLoading={isLoading}
          color="primary"
          variant="contained"
          startIcon={<ExportIcon />}
        >
          Export shift data
        </ExportButton>
      </Typography>
    </Section>
  );
}
